<template>
    <!--==== Sidebar ====-->
    <aside class="col-12 col-md-3 col-xl-2 p-0">
        <nav class="navbar navbar-expand-md navbar-dark bd-dark flex-md-column flex-row align-items-center py-2 sticky-top"
            id="sidebar">
            <div class="text-center p-3">
                <router-link :to="`/`">
                    <img src="@/assets/logo.png" alt="Tech For Filipino Youth Organization" width="170"
                    class="img-fluid my-4 p-1 d-none d-md-block" />
                </router-link>
                <a class="navbar-brand mx-0 font-weight-bold text-nowrap">Navigation </a>
            </div>
            <button class="navbar-toggler me-2" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse col-10 order-last text-md-start" id="navbarSupportedContent">
                <ul class="navbar-nav flex-column w-100 justify-content-start">
                    <li class="nav-item">

                        <router-link v-if="$route.path !== '/events'" :to="`/events`" class="nav-link">
                            <font-awesome-icon icon="fa-solid fa-calendar-days" class="fa-fw" /> <span class="ml-1"> EVENTS </span>
                        </router-link>

                        <router-link v-else :to="`/events`" class="nav-link active" aria-current="page">
                            <font-awesome-icon icon="fa-solid fa-calendar-days" class="fa-fw" /> <span class="ml-1"> EVENTS </span>
                        </router-link>

                    </li>
                    <li class="nav-item">

                        <router-link v-if="$route.path !== '/add-event'" :to="`/add-event`" class="nav-link">
                            <font-awesome-icon icon="fa-solid fa-calendar-plus" class="fa-fw"/> <span class="ml-1"> ADD EVENTS </span>
                        </router-link>

                        <router-link v-else class="nav-link active" :to="`/add-event`" aria-current="page">
                            <font-awesome-icon icon="fa-solid fa-calendar-plus" class="fa-fw"/> <span class="ml-1"> ADD EVENTS </span>
                        </router-link>

                    </li>
                    <li class="nav-item">

                        <router-link v-if="$route.path !== '/beneficiaries'" :to="`/beneficiaries`" class="nav-link">
                            <font-awesome-icon icon="fa-solid fa-people-group" class="fa-fw" /> <span class="ml-1"> BENEFICIARIES </span>
                        </router-link>

                        <router-link v-else :to="`/beneficiaries`" class="nav-link active" aria-current="page">
                            <font-awesome-icon icon="fa-solid fa-people-group" class="fa-fw" /> <span class="ml-1"> BENEFICIARIES </span>
                        </router-link>

                    </li>
                    <li class="nav-item">

                        <router-link v-if="$route.path !== '/volunteers'" :to="`/volunteers`" class="nav-link">
                            <font-awesome-icon icon="fa-solid fa-handshake-angle" class="fa-fw" /> <span class="ml-1"> VOLUNTEERS </span>
                        </router-link>

                        <router-link v-else :to="`/volunteers`" class="nav-link active" aria-current="page">
                            <font-awesome-icon icon="fa-solid fa-handshake-angle" class="fa-fw" /> <span class="ml-1"> VOLUNTEERS </span>
                        </router-link>

                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-danger fw-semibold" @click="logout()" role="button">
                            <font-awesome-icon icon="fa-solid fa-right-from-bracket" clas="fa-fw" /> <span class="ml-1"> LOG OUT </span>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    
    </aside>
</template>

<script>
import store from '@/store'

export default {
    methods: {
        logout() {
            store.dispatch('auth/logout')
        }
    }
}
</script>

<style scoped src="@/assets/css/admin.css">
</style>